import React from 'react';
import { Ordinal } from '@components/Feed/ListViews/components/Oridinal';
import { MINT_COMPONENT_HEADING_SUBTEXT } from '@components/Song/MintComponents/shared/constants';
import BadgeImage from '@components/Tiers/BadgeImage';
import { Tooltip } from '@components/main-components/tooltip/Tooltip';
import { SPACE } from '@utils/constants';
import { TIER_NUMBERS, TIERS } from '@utils/tiers';
import { FeedListViewSubText } from './shared';

export default function SingleQuantity({
  tierNumber,
  edition,
  goldenEgg,
}: {
  tierNumber: TIER_NUMBERS | null;
  edition: number;
  goldenEgg?: boolean;
}) {
  return (
    <Tooltip openOnClick={false}>
      <Tooltip.Trigger>
        <FeedListViewSubText className="group flex items-center">
          {tierNumber === TIER_NUMBERS.LIMITED && (
            <>
              <BadgeImage type={goldenEgg ? 'goldenEgg' : TIERS.LIMITED} />
              {SPACE}
            </>
          )}
          <Ordinal edition={edition} className="transition-colors group-hover:text-base400" />
        </FeedListViewSubText>
      </Tooltip.Trigger>
      <Tooltip.StyledContent size="sm">
        {tierNumber === TIER_NUMBERS.LIMITED
          ? MINT_COMPONENT_HEADING_SUBTEXT.FALLBACK.heading
          : MINT_COMPONENT_HEADING_SUBTEXT.FREE.heading}
        {SPACE}
        <Ordinal edition={edition} className="md:text-base-s lg:text-base-s" />
      </Tooltip.StyledContent>
    </Tooltip>
  );
}
